// NOMAD-MON GO! 2 — PRISM tilt. Writes --tx/--ty (-1..1) on the title lockup
// so it parallaxes with the pointer / device tilt. At most one rAF-throttled
// style write per input frame, on one element; nothing under reduced motion
// and nothing while the title is hidden (offsetParent null = display:none).
export function initPrismTilt({ reduced = false } = {}) {
  initGlowFollow();
  const el = document.getElementById('logoWrap');
  if (reduced || !el) return;
  let x = 0, y = 0, queued = false;
  const flush = () => {
    queued = false;
    el.style.setProperty('--tx', x.toFixed(3));
    el.style.setProperty('--ty', y.toFixed(3));
  };
  const set = (nx, ny) => {
    x = Math.max(-1, Math.min(1, nx)); y = Math.max(-1, Math.min(1, ny));
    if (!queued && el.offsetParent !== null) { queued = true; requestAnimationFrame(flush); }
  };
  addEventListener('pointermove', (e) => set((e.clientX / innerWidth) * 2 - 1, (e.clientY / innerHeight) * 2 - 1),
    { passive: true });
  addEventListener('deviceorientation', (e) => {
    if (e.gamma == null || e.beta == null) return;
    set(e.gamma / 35, (e.beta - 45) / 45);
  }, { passive: true });
}

// FRONT DOOR 3: the kit's hover highlight follows the cursor. Mouse/pen only,
// one rAF-throttled --mx/--my write on the hovered control; touch never pays.
const GLOW = '.enchip, #entryGo, .v2-btn, .pill, .v2-chip';
function initGlowFollow() {
  if (!matchMedia('(hover: hover)').matches) return;
  let target = null, mx = 0, my = 0, queued = false;
  const flush = () => {
    queued = false;
    if (!target) return;
    target.style.setProperty('--mx', `${mx.toFixed(0)}px`);
    target.style.setProperty('--my', `${my.toFixed(0)}px`);
  };
  addEventListener('pointermove', (e) => {
    if (e.pointerType === 'touch') return;
    const t = e.target instanceof Element ? e.target.closest(GLOW) : null;
    if (!t) { target = null; return; }
    const r = t.getBoundingClientRect();
    target = t; mx = e.clientX - r.left; my = e.clientY - r.top;
    if (!queued) { queued = true; requestAnimationFrame(flush); }
  }, { passive: true });
}
